var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"mouseover":_vm.onOver,"mouseleave":_vm.onLeave}},[_c('b-dropdown',{ref:"dropdown",staticClass:"navbar-brand bg select-box",staticStyle:{"line-height":"1"},attrs:{"id":_vm.id,"text":_vm.text}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }